import { render } from "./WarningRule.vue?vue&type=template&id=b3f2ff48&scoped=true"
import script from "./WarningRule.vue?vue&type=script&lang=js"
export * from "./WarningRule.vue?vue&type=script&lang=js"

import "./WarningRule.vue?vue&type=style&index=0&id=b3f2ff48&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3f2ff48"]])

export default __exports__